import DOMPurify from 'dompurify';
import React from 'react';

import { ReactComponent as SuccessIcon } from '../../assets/images/checkCircle.svg';
import { ReactComponent as InfoIcon } from '../../assets/images/infoSign.svg';
import { ReactComponent as WarningIcon } from '../../assets/images/warning.svg';
import {
  AlertContainerStyled,
  AlertHeaderStyled,
  AlertTextContainerStyled,
  AlertTextStyled,
  Error,
  TitleStyled,
} from './styled';

type AlertType = 'warning' | 'error' | 'info' | 'success';
type AlertProps = {
  type: AlertType;
  text: string;
  title?: string;
};

const alertConfigMap = {
  warning: { title: 'Warning', alertIcon: <WarningIcon /> },
  error: { title: 'Error', alertIcon: <Error /> },
  info: { title: 'Information', alertIcon: <InfoIcon /> },
  success: { title: 'Success', alertIcon: <SuccessIcon /> },
};

const AdmanAlert = ({ type, text, title }: AlertProps): JSX.Element => {
  const { title: defaultTitle, alertIcon } = alertConfigMap[type];
  const resolvedTitle = title ?? defaultTitle;

  return (
    <AlertContainerStyled data-testid="alertContainer">
      <AlertHeaderStyled>
        {alertIcon}
        <AlertTextContainerStyled>
          <TitleStyled data-testid="alertTitle">{resolvedTitle}</TitleStyled>
          <AlertTextStyled
            className="alertTextStyled"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(text, { ALLOWED_TAGS: ['a'], ALLOWED_ATTR: ['href', 'target', 'rel'] }),
            }}
          />
        </AlertTextContainerStyled>
      </AlertHeaderStyled>
    </AlertContainerStyled>
  );
};

export default AdmanAlert;
